String.prototype.removeInvisibleSpaceChars = function (
  ...args: string[]
): string {
  return this.replace(/[^\x00-\x7F]/g, "");
};

// https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore
Array.prototype.groupBy = function <T>(keyFn: (item: T) => string): {
  [key: string]: Array<T>;
} {
  return this.reduce(
    (r, v, i, a, k = keyFn(v)) => ((r[k] || (r[k] = [])).push(v), r),
    {},
  );
};

Number.prototype.toDecimalPlaces = function (dp: number): number {
  return parseFloat(this.toFixed(dp));
};
